export const removeDuplicates = <T>(arr: T[], keySelector: (item: T) => string): T[] => {
  const uniqueKeys: { [key: string]: boolean } = {};
  return arr.filter(obj => {
    const key = keySelector(obj);
    if (uniqueKeys[key]) return false;
    uniqueKeys[key] = true;
    return true;
  });
}